import Cookies from 'universal-cookie';

const cookies = new Cookies();

// Cookies
const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';

export default class AuthUtils {
  static disableRememberMe() {
    cookies.remove(REFRESH_TOKEN, { path: '/' });
  }

  static destroyToken() {
    cookies.remove(ACCESS_TOKEN, { path: '/' });
    AuthUtils.disableRememberMe();
  }

  static getAccessToken() {
    return cookies.get(ACCESS_TOKEN);
  }

  static getRefreshToken() {
    return cookies.get(REFRESH_TOKEN);
  }

  static saveToken(token, rememberMe) {
    const expireDate = new Date().getTime() + (1000 * token.expires_in);
    cookies.set(ACCESS_TOKEN, token.access_token, { path: '/', expires: new Date(expireDate) });

    if (rememberMe) {
      // Setting cookie maxAge to one year from now
      cookies.set(REFRESH_TOKEN, token.refresh_token, { path: '/', maxAge: 365 * 24 * 60 * 60 });
    } else {
      AuthUtils.disableRememberMe();
    }
  }
}
